import React from "react";

import styles from "./ContactInfo.module.scss";
import PreviousPage from "../../../partials/PreviousPage/PreviousPage";
import DataCollector from "../../../UI/DataCollector/DataCollector";
import SubmitContactForm from "../../../partials/SubmitContactForm/SubmitContactForm";

const ContactInfo: React.FC = () => {
  return (
    <section className={styles.contactInfo}>
      <div className="container">
        {<PreviousPage currentPage="Вакансии" title="Вакансии" />}
        <form className={styles.form}>
          <h3 className={styles.subtitle}>Контактная информация</h3>
          <div className={styles.top}>
            <div className={styles.item}>
              <DataCollector mode="regular" title="ФИО*" />
            </div>
            <div className={styles.item}>
              <DataCollector mode="tel" title="Телефон*" placeholder="+7 (999) 999-9999" />
            </div>
            <div className={styles.item}>
              <DataCollector mode="date" title="Дата рождения*" />
            </div>
            <div className={styles.item}>
              <DataCollector
                mode="select"
                title="Гражданство*"
                itemList={[
                  { id: 0, text: "-" },
                  { id: 1, text: "РФ" },
                  { id: 2, text: "Другое" },
                ]}
              />
            </div>
          </div>
          <div className={styles.adress}>
            <DataCollector mode="regular" title="Адрес проживания фактический*" />
          </div>
          <div className={styles.bottom}>
            <div className={styles.item}>
              <DataCollector
                mode="select"
                title="Образование*"
                itemList={[
                  { id: 0, text: "-" },
                  { id: 1, text: "Высшее" },
                  { id: 2, text: "Среднее-техническое" },
                  { id: 3, text: "Среднее" },
                  { id: 4, text: "Другое" },
                ]}
              />
            </div>
            <div className={styles.item}>
              <DataCollector
                mode="select"
                title="Опыт работы*"
                itemList={[
                  { id: 0, text: "-" },
                  { id: 1, text: "Есть" },
                  { id: 2, text: "Нет" },
                ]}
              />
            </div>
            <div className={styles.item}>
              <DataCollector
                mode="select"
                title="Желемая должность*"
                itemList={[
                  { id: 0, text: "-" },
                  { id: 1, text: "Управляющий складом" },
                  { id: 2, text: "Сотрудник склада" },
                  { id: 3, text: "Резчик" },
                  { id: 4, text: "Упаковщик" },
                  { id: 5, text: "Контент-менеджер" },
                  { id: 6, text: "Менеджер по продажам" },
                  { id: 7, text: "Администратор зала" },
                  { id: 8, text: "Сотрудник службы безопасности" },
                  { id: 9, text: "Бухгалтер - кадровик" },
                  { id: 10, text: "Ассистент руководителя" },
                  { id: 11, text: "Бухгалтер-материалист" },
                  { id: 12, text: "Продавец консультант (фурнитура)" },
                ]}
              />
            </div>
            <div className={styles.item}>
              <DataCollector mode="select" title="Желаемое место работы*" itemList={[{ id: 0, text: "-" }]} />
            </div>
          </div>
          <SubmitContactForm />
        </form>
      </div>
    </section>
  );
};

export default ContactInfo;
